export default {
  ratePlanType: {
    STANDARD: 'Standard',
    BAR: 'Melhor tarifa disponível',
    CORPORATE: 'Corporativa',
    MEMBER: 'Membro',
    PACKAGE: 'Pacote',
    PROMOTIONAL: 'Promocional',
    OTA: 'OTA',
    WHOLESALE: 'Atacado',
    NEGOTIATED: 'Negociada',
    MIXED: 'Tarifa combinada',
  },
} as const;
